import { createLogger, getTelemetry } from '@moniebook-web/utils';

import { useBusinessStore, useStaffSessionStore } from './store';

export const telemetry = getTelemetry({
    hostVersion: __HOST_UI_VERSION__,
    mfeManifest: [],
    getContext() {
        return {
            businessId: useBusinessStore.getState().businessInfo?.businessId,
            staffId: useStaffSessionStore.getState().staffId,
            userId: useStaffSessionStore.getState().userId,
            branchId: useBusinessStore.getState().businessInfo?.branchId,
            register: useBusinessStore.getState().businessInfo?.registerName,
        };
    },
});

export const logger = createLogger('web-register');
